import isNumber from 'lodash/isNumber'
import { toNumber } from '@shared/lib'

export const PENNY = 100 as const
export const convertPennyToBanknote = (amountPenny: number) =>
  isNumber(toNumber(amountPenny)) ? Number((amountPenny / PENNY).toFixed(2)) : null

export const messages = {
  // Base
  required: 'Заполните поле',
  min: (min) => `Значение должно быть не менее ${min} символов`,
  max: (max) => `Сообщение должно быть не более ${max} символов`,
  minMax: (min, max) => `Значение должно быть не менее ${min} символов и не более ${max} символов`,

  // Custom
  balance: {
    min: 'На счёте недостаточно средств. Выберите другой счёт или измените сумму пополнения',
    max: (max) => `Сумма должна быть меньше максимальной суммы ${max} `,
    minMax: (min, max) => `Сумма должна быть больше минимальной суммы ${min} и не превышать максимальную сумму ${max}`,
  },
  // repaymentAmount: {
  //   balance: 'На\u00A0счёте недостаточно средств. Выберите другой счёт или измените сумму платежа',
  //   balanceWithFee: 'С\u00A0учётом комиссии недостаточно средств',
  //   min: (value: number) => `Минимальная сумма\u00A0\u2014 ${toPriceFormat(convertPennyToBanknote(value), { trimIfInteger: true })} ₽`,
  //   max: (value: number) => `Максимальная сумма\u00A0\u2014 ${toPriceFormat(convertPennyToBanknote(value), { trimIfInteger: true })} ₽`, // todo отрефакторить: value в min & max должен быть только вывод текста без трансформаций
  // },
  creditCard: {
    format: 'Укажите правильный номер карты',
    invalidExpiryDate: 'Укажите правильный срок действия',
    expired: 'Дата действия карты должна быть больше текущей',
    isDublicateNumberCard: 'Номер карты получателя, совпадает с\u00A0номером карты отправителя',
  },
  paymentAmount: {
    min: (value) => `Минимальная сумма ${value}`,
    max: (value) => `Максимальная сумма ${value}`,
  },
  email: {
    required: 'Проверьте адрес электронной почты',
  },
  depositAccount: {
    min: (value: string) => `Не\u00A0хватает ${value}. Пополните счет и возвращайтесь`,
  },
}
